import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { CouponItem } from '@/models/Coupon';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class CouponsService {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getCoupons(form: any, id?: number) {
        const path = id ?
        `${this.baseAPI}/coupons/${id}` :
        `${this.baseAPI}/coupons?q=kyotenCd=${form.kyotenCd},groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getCoupons');
            return;
        }
    }

    public async editCoupons(data: CouponItem) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/coupons/`, {
            ...data
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editCoupons');
            return;
        }
    }

    public async deleteCoupons(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/coupons/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteCoupons');
            return;
        }
    }

    public async saveCoupons(data: any[], base: any) {
        const q = `groupCd=${base.groupCd},shatenCd=${base.shatenCd},kyotenCd=${base.kyotenCd}`;
        const { result, error } = await this.commonService.put(`${this.baseAPI}/coupons-order-display?q=${q}`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async cloneData(data: any[]) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/coupons-clone`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public getCouponLimit(form: any) {
        const path = 
        `${this.baseAPI}/coupon-limit?q=kyotenCd=${form.kyotenCd},groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        return this.commonService.get(path);
    }

    public async saveCouponLimit(data: any) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/coupon-limit`, data);
        if (result) {
            return result.status;
        } else {
            return error.status;
        }
    }

    public async updateCouponLimit(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/coupon-limit`, data);
        if (result) {
            return result.status;
        } else {
            return error.status;
        }
    }

    // ============================





}
